module.exports = __webpack_public_path__ + "static/media/location_helsinki.45e23cad.jpg";